import { MuscleCategories } from '../type/categories'

export const musclesCategorized: Readonly<MuscleCategories> = [
	{
		group_code: 'BACK',
		group_name_ru: 'Спина',
		group_name_en: 'Back Muscles',
		muscles: [
			{
				code: 'upper_trapezius',
				name_ru: 'Верхняя часть трапеций',
				name_en: 'Upper Trapezius',
			},
			{
				code: 'lower_trapezius',
				name_ru: 'Нижняя часть трапеций',
				name_en: 'Lower Trapezius',
			},
			{
				code: 'latissimus_dorsi',
				name_ru: 'Широчайшие мышцы спины',
				name_en: 'Latissimus Dorsi',
			},
			{
				code: 'trapezius',
				name_ru: 'Трапеции (общее)',
				name_en: 'Trapezius',
			},
			{
				code: 'erector_spinae',
				name_ru: 'Разгибатели спины',
				name_en: 'Erector Spinae',
			},
			{
				code: 'rhomboids',
				name_ru: 'Ромбовидные мышцы',
				name_en: 'Rhomboids',
			},
			{
				code: 'iliopsoas',
				name_ru: 'Подвздошно-поясничная мышца',
				name_en: 'Iliopsoas',
			},
			{
				code: 'lower_back_muscles',
				name_ru: 'Мышцы нижней части спины',
				name_en: 'Lower Back Muscles',
			},
		],
	},
	{
		group_code: 'CHEST',
		group_name_ru: 'Грудь',
		group_name_en: 'Chest Muscles',
		muscles: [
			{
				code: 'upper_chest',
				name_ru: 'Верхняя часть грудных мышц',
				name_en: 'Upper Chest (Clavicular Head of Pectoralis Major)',
			},
			{
				code: 'inner_chest',
				name_ru: 'Внутренняя часть грудных мышц',
				name_en: 'Inner Chest',
			},
			{
				code: 'pectoralis_major',
				name_ru: 'Грудные мышцы (общее)',
				name_en: 'Pectoralis Major',
			},
			{
				code: 'lower_chest',
				name_ru: 'Нижняя часть груди',
				name_en: 'Lower Chest (Sternocostal Head of Pectoralis Major)',
			},
		],
	},
	{
		group_code: 'ARMS',
		group_name_ru: 'Руки',
		group_name_en: 'Arm Muscles',
		muscles: [
			{
				code: 'biceps_brachii',
				name_ru: 'Бицепсы',
				name_en: 'Biceps Brachii',
			},
			{
				code: 'brachialis',
				name_ru: 'Плечевая мышца (brachialis)',
				name_en: 'Brachialis',
			},
			{
				code: 'brachioradialis',
				name_ru: 'Плечелучевая мышца',
				name_en: 'Brachioradialis',
			},
			{
				code: 'triceps_brachii',
				name_ru: 'Трицепсы',
				name_en: 'Triceps Brachii',
			},
			{
				code: 'forearm_muscles',
				name_ru: 'Мышца предплечья',
				name_en: 'Forearm Muscles',
			},
		],
	},
	{
		group_code: 'SHOULDERS',
		group_name_ru: 'Плечи',
		group_name_en: 'Shoulder Muscles',
		muscles: [
			{
				code: 'deltoid_anterior',
				name_ru: 'Передние дельтовидные мышцы',
				name_en: 'Anterior Deltoid',
			},
			{
				code: 'deltoid_posterior',
				name_ru: 'Задние дельтовидные мышцы',
				name_en: 'Posterior Deltoid',
			},
			{
				code: 'deltoid',
				name_ru: 'Дельтовидные мышцы (все три пучка)',
				name_en: 'Deltoid (All Heads)',
			},
		],
	},
	{
		group_code: 'ABS',
		group_name_ru: 'Пресс',
		group_name_en: 'Core Muscles',
		muscles: [
			{
				code: 'rectus_abdominis',
				name_ru: 'Прямая мышца живота',
				name_en: 'Rectus Abdominis',
			},
			{
				code: 'obliques',
				name_ru: 'Косые мышцы живота',
				name_en: 'Obliques',
			},
			{
				code: 'transversus_abdominis',
				name_ru: 'Поперечная мышца живота',
				name_en: 'Transversus Abdominis',
			},
			{
				code: 'erector_spinae_core',
				name_ru: 'Разгибатели спины',
				name_en: 'Erector Spinae',
			},
			{
				code: 'iliopsoas_core',
				name_ru: 'Подвздошно-поясничная мышца',
				name_en: 'Iliopsoas',
			},
		],
	},
	{
		group_code: 'LEGS_GLUTES',
		group_name_ru: 'Ноги',
		group_name_en: 'Leg and Glute Muscles',
		muscles: [
			{
				code: 'quadriceps',
				name_ru: 'Квадрицепсы',
				name_en: 'Quadriceps',
			},
			{
				code: 'glutes',
				name_ru: 'Ягодичные мышцы',
				name_en: 'Gluteal Muscles',
			},
			{
				code: 'hamstrings',
				name_ru: 'Бицепсы бедра',
				name_en: 'Hamstrings',
			},
			{
				code: 'gastrocnemius',
				name_ru: 'Икроножные мышцы',
				name_en: 'Gastrocnemius',
			},
			{
				code: 'soleus',
				name_ru: 'Камбаловидная мышца',
				name_en: 'Soleus',
			},
			{
				code: 'calves',
				name_ru: 'Мышцы голени (общее)',
				name_en: 'Calves',
			},
			{
				code: 'iliopsoas_legs',
				name_ru: 'Подвздошно-поясничная мышца',
				name_en: 'Iliopsoas',
			},
			{
				code: 'triceps_femoris',
				name_ru: 'Трицепс бедра',
				name_en: 'Triceps Femoris',
			},
		],
	},
	{
		group_code: 'OTHER',
		group_name_ru: 'Прочие мышцы',
		group_name_en: 'Other Muscles',
		muscles: [
			{
				code: 'cardio',
				name_ru: 'Кардио',
				name_en: 'Cardio',
			},
		],
	},
]
